import { Component, OnInit } from '@angular/core';
import {ModalExtended} from 'ngx-dynamic-modal';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ResponseConfigDelayService} from '../../services/response-config-delay.service';
import {AlertaService} from '../../../../../shared/services/alerta.service';

@Component({
  selector: 'app-response-config-delay-modal',
  templateUrl: './response-config-delay-modal.component.html',
  styleUrls: ['./response-config-delay-modal.component.scss']
})
export class ResponseConfigDelayModalComponent extends ModalExtended implements OnInit {

  data:any;
  formSearch:FormGroup;
  params:any;
  element:any;

  loading: boolean = false;

  constructor(private fb:FormBuilder,
              private respDelayService: ResponseConfigDelayService,
              private alerta:AlertaService) {
      super();
      this.formSearch = new FormGroup(
          {
              'active':new FormControl('0'),
              'response':new FormControl(''),
              'delay':new FormControl('',Validators.required),
              'max_attempts':new FormControl('',[Validators.required,Validators.min(1)])
          });

  }

  ngOnInit() {
      this.params=this.data.params;
      if(this.data.element){
          this.element=this.data.element;
          this.formSearch = this.fb.group({
              'active':new FormControl(this.element.active),
              'response':new FormControl(this.element.response),
              'delay':new FormControl(this.element.delay,Validators.required),
              'max_attempts':new FormControl(this.element.max_attempts,[Validators.required,Validators.min(1)])
          });
      }
  }

  saveData(form){
        if(form.valid){
            this.loading = true;
            let element=form.value;
            element['portal_pk']=this.params.portal_pk;
            element['service_pk']=this.params.service_pk;
            if(this.params.hasOwnProperty('camp_pk') && this.params.camp_pk > 0){
                element['service_campaign_pk']=this.params.camp_pk;
            }
            this.respDelayService.postRespConfigDelay(element)
                .subscribe(result=>{
                    this.onExit({edit:false,element:result.data});
                    this.loading = false;
                }, error => {
                    //console.log(error);
                    this.alerta.addAlert('error','Something went wrong')
                }, () => {
                    this.alerta.addAlert('success','Response Delay Config Created Succesfully!!')
                })
        }
  }

  updateData(form){
        if(form.valid) {
            this.loading = true;
            let element = form.value;
            element['pk']=this.element.pk;
            this.respDelayService.putRespConfigDelay(element)
                .subscribe(result => {
                    this.onExit({edit:true,element:result.data});
                    this.loading = false;
                }, error => {
                    //console.log(error);
                    this.alerta.addAlert('error','Something went wrong')
                }, () => {
                    this.alerta.addAlert('success','Response Delay Config Updated Succesfully!!')
                })
        }
  }

  onExit(data) {
        this.applyCallback(data);
        this.close();
  }


}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/modals/response-config-delay-modal/response-config-delay-modal.component.ts